import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import InvoiceDetailsPage from '../resources/Invoices/pages/InvoiceDetailsPage';
import CreateInvoicePage from '../resources/Invoices/pages/CreateInvoicePage';
import CreditNoteDetailsPage from '../resources/creditNotes/pages/CreditNoteDetailsPage';
import RefundDetailsPage from '../resources/refunds/pages/RefundDetailsPage';
import DebitNoteDetailsPage from '../resources/debitNotes/pages/DebitNoteDetailsPage';
import CustomerDetailsPage from '../resources/customers/pages/CustomerDetailsPage';
import SBCreditNoteDetailsPage from '../resources/selfBilledCreditNotes/pages/SBCreditNoteDetailsPage';
import SBRefundDetailsPage from '../resources/selfBilledRefunds/pages/SBRefundDetailsPage';
import EditCustomerPage from '../resources/customers/pages/EditCustomerPage';
import CustomerListPage from '../resources/customers/pages/CustomerListPage';
import CreateCustomersPage from '../resources/customers/pages/CreateCustomersPage';
import SupplierListPage from '../resources/suppliers/pages/SupplierListPage';
import SupplierDetailsPage from '../resources/suppliers/pages/SupplierDetailsPage';
import EditSupplierPage from '../resources/suppliers/pages/EditSupplierPage';
import CreateSuppliersPage from '../resources/suppliers/pages/CreateSuppliersPage';
import SettingsPage from '../resources/settings/pages/SettingsPage';
import BulkUploadListPage from '../resources/bulkUpload/pages/BulkUploadListPage';
import CreateCreditNotePage from '../resources/creditNotes/pages/CreateCreditNotePage';
import CreateDebitNotePage from '../resources/debitNotes/pages/CreateDebitNotePage';
import CreateRefundPage from '../resources/refunds/pages/CreateRefundPage';
import CreateSBInvoicePage from '../resources/selfBilledInvoices/pages/CreateSBInvoicePage';
import SBInvoiceDetailsPage from '../resources/selfBilledInvoices/pages/SBInvoiceDetailsPage';
import CreateSBCreditNotePage from '../resources/selfBilledCreditNotes/pages/CreateSBCreditNotePage';
import SBDebitNoteDetailsPage from '../resources/selfBilledDebitNotes/pages/SBDebitNoteDetailsPage';
import CreateSBDebitNotePage from '../resources/selfBilledDebitNotes/pages/CreateSBDebitNotePage';
import CreateSBRefundPage from '../resources/selfBilledRefunds/pages/CreateSBRefundPage';
import BusinessProfileListPage from '../resources/businessProfiles/pages/BusinessProfileListPage';
import BusinessProfileDetailsPage from '../resources/businessProfiles/pages/BusinessProfileDetailsPage';
import EditBusinessProfilePage from '../resources/businessProfiles/pages/EditBusinessProfilePage';
import CreateBusinessProfilePage from '../resources/businessProfiles/pages/CreateBusinessProfilePage';
import DraftDocumentListPage from '../resources/draftDocuments/pages/DraftDocumentListPage';
import SBDraftDocumentListPage from '../resources/selfBilledDraftDocuments/pages/SBDraftDocumentListPage';
import DraftsInvoiceDetailsPage from '../resources/draftDocuments/pages/DraftsInvoiceDetailsPage';
import DraftsCreditNoteDetailsPage from '../resources/draftDocuments/pages/DraftsCreditNoteDetailsPage';
import DraftsDebitNoteDetailsPage from '../resources/draftDocuments/pages/DraftsDebitNoteDetailsPage';
import DraftsRefundDetailsPage from '../resources/draftDocuments/pages/DraftsRefundDetailsPage';
import SBDraftInvoiceDetailsPage from '../resources/selfBilledDraftDocuments/pages/SBDraftInvoiceDetailsPage';
import SBDraftRefundDetailsPage from '../resources/selfBilledDraftDocuments/pages/SBDraftRefundDetailsPage';
import SBDraftDebitNoteDetailsPage from '../resources/selfBilledDraftDocuments/pages/SBDraftDebitNoteDetailsPage';
import SBDraftCreditNoteDetailsPage from '../resources/selfBilledDraftDocuments/pages/SBDraftCreditNoteDetailsPage';
import DashboardPage from '../resources/dashboard/pages/dashboardPage';
import DocumentReportPage from '../resources/documentReports/pages/DocumentReportPage';
import PeppolMessagesListPage from '../resources/peppolMessages/pages/PeppolMessagesListPage';
import TeamPage from '../resources/teamSection/pages/TeamPage';
import ProductListPage from '../resources/products/pages/ProductListPage';
import DocumentListPage from '../resources/DocumentListPage';
import SBDocumentListPage from '../resources/SBDocumentListPage';
import PdfDataExtractionListPage from '../resources/pdfDataExtraction/pages/PdfDataExtractionListPage';
import BulkPDFDownloadPage from '../resources/bulkPDFDownload/pages/BulkPDFReportPage';

const FTUXProvider = ({ element, totalBusinessProfiles }) => {
  const shouldRedirect = totalBusinessProfiles === 0;

  if (shouldRedirect) {
    return <Navigate to="/business-profiles/create" replace />;
  }

  return element;
};

const AuthenticatedRoutes = (totalBusinessProfiles) => {
  let configuredFeatures = [];

  configuredFeatures.push(
    <React.Fragment key={'dashboard'}>
      <Route
        path={`/dashboard`}
        element={<FTUXProvider element={<DashboardPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'products'}>
      <Route
        path={`/products`}
        element={<FTUXProvider element={<ProductListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'business-profiles'}>
      <Route path={`/business-profiles`} element={<BusinessProfileListPage />} />
      <Route path={`/business-profiles/:profile_id`} element={<BusinessProfileDetailsPage />} />
      <Route path={`/business-profiles/:profile_id/edit`} element={<EditBusinessProfilePage />} />
      <Route path={`/business-profiles/create`} element={<CreateBusinessProfilePage />} />
    </React.Fragment>,

    <React.Fragment key={'customers'}>
      <Route
        path={`/customers`}
        element={<FTUXProvider element={<CustomerListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/customers/:profile_id`}
        element={<FTUXProvider element={<CustomerDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/customers/:profile_id/edit`}
        element={<FTUXProvider element={<EditCustomerPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/customers/create`}
        element={<FTUXProvider element={<CreateCustomersPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'suppliers'}>
      <Route
        path={`/suppliers`}
        element={<FTUXProvider element={<SupplierListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/suppliers/:profile_id`}
        element={<FTUXProvider element={<SupplierDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/suppliers/:profile_id/edit`}
        element={<FTUXProvider element={<EditSupplierPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/suppliers/create`}
        element={<FTUXProvider element={<CreateSuppliersPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'documents'}>
      <Route
        path={`/documents`}
        element={<FTUXProvider element={<DocumentListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/documents/invoices/:document_id`}
        element={<FTUXProvider element={<InvoiceDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/documents/invoices/create`}
        element={<FTUXProvider element={<CreateInvoicePage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/documents/credit-notes/:document_id`}
        element={<FTUXProvider element={<CreditNoteDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/documents/credit-notes/create`}
        element={<FTUXProvider element={<CreateCreditNotePage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/documents/debit-notes/:document_id`}
        element={<FTUXProvider element={<DebitNoteDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/documents/debit-notes/create`}
        element={<FTUXProvider element={<CreateDebitNotePage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/documents/refunds/:document_id`}
        element={<FTUXProvider element={<RefundDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/documents/refunds/create`}
        element={<FTUXProvider element={<CreateRefundPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'drafts'}>
      <Route
        path={`/drafts`}
        element={<FTUXProvider element={<DraftDocumentListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/drafts/invoices/:document_id`}
        element={<FTUXProvider element={<DraftsInvoiceDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/drafts/credit-notes/:document_id`}
        element={
          <FTUXProvider element={<DraftsCreditNoteDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />
        }
      />
      <Route
        path={`/drafts/debit-notes/:document_id`}
        element={
          <FTUXProvider element={<DraftsDebitNoteDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />
        }
      />
      <Route
        path={`/drafts/refunds/:document_id`}
        element={<FTUXProvider element={<DraftsRefundDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'self-billed-drafts'}>
      <Route
        path={`/self-billed-drafts`}
        element={<FTUXProvider element={<SBDraftDocumentListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-drafts/invoices/:document_id`}
        element={<FTUXProvider element={<SBDraftInvoiceDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-drafts/refunds/:document_id`}
        element={<FTUXProvider element={<SBDraftRefundDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-drafts/credit-notes/:document_id`}
        element={
          <FTUXProvider element={<SBDraftCreditNoteDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />
        }
      />
      <Route
        path={`/self-billed-drafts/debit-notes/:document_id`}
        element={
          <FTUXProvider element={<SBDraftDebitNoteDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />
        }
      />
    </React.Fragment>,

    <React.Fragment key={'self-billed-documents'}>
      <Route
        path={`/self-billed-documents`}
        element={<FTUXProvider element={<SBDocumentListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-documents/invoices/:document_id`}
        element={<FTUXProvider element={<SBInvoiceDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-documents/invoices/create`}
        element={<FTUXProvider element={<CreateSBInvoicePage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-documents/credit-notes/:document_id`}
        element={<FTUXProvider element={<SBCreditNoteDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-documents/credit-notes/create`}
        element={<FTUXProvider element={<CreateSBCreditNotePage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-documents/debit-notes/:document_id`}
        element={<FTUXProvider element={<SBDebitNoteDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-documents/debit-notes/create`}
        element={<FTUXProvider element={<CreateSBDebitNotePage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-documents/refunds/:document_id`}
        element={<FTUXProvider element={<SBRefundDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/self-billed-documents/refunds/create`}
        element={<FTUXProvider element={<CreateSBRefundPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'settings'}>
      <Route
        path={`/settings`}
        element={<FTUXProvider element={<SettingsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/settings/members/add`}
        element={<FTUXProvider element={<TeamPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/settings/members/edit`}
        element={<FTUXProvider element={<TeamPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'bulk-upload'}>
      <Route
        path={`/bulk-upload`}
        element={<FTUXProvider element={<BulkUploadListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={`/bulk-upload/:id`}
        element={<FTUXProvider element={<SupplierDetailsPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'pdf-data-extraction'}>
      <Route
        path={`/ai-tools/pdf-data-extraction`}
        element={<FTUXProvider element={<PdfDataExtractionListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'reporting-reconciliation'}>
      <Route
        path={`reporting-reconciliation/document-report`}
        element={<FTUXProvider element={<DocumentReportPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
      <Route
        path={'reporting-reconciliation/bulk-pdf-download'}
        element={<FTUXProvider element={<BulkPDFDownloadPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,

    <React.Fragment key={'peppol-messages'}>
      <Route
        path={`/peppol-messages`}
        element={<FTUXProvider element={<PeppolMessagesListPage />} totalBusinessProfiles={totalBusinessProfiles} />}
      />
    </React.Fragment>,
  );

  return configuredFeatures;
};

export default AuthenticatedRoutes;
